export default __webpack_public_path__ + "static/media/HotJobIconChip.1045b900.svg";